module.exports = __webpack_public_path__ + "6d38572bc7bf15823d1869e8f50b795b.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room6/audio1/06_MCA-A-La-Belle-Etoile.ogg
// module id = 787
// module chunks = 0